import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/css/common.css";
import Router, { history } from "../Router";
import { BrowserRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import Popup from "../../components/Popup";
import PopupCardTemplate from "../../components/PopupCardTemplate";
import NotificationAlertCard from "../../components/NotificationAlertCard";
import { setError } from "../../reducers/error";
import { setLoading } from "../../reducers/loading";
import "../../assets/css/TopSection.css";
import "../../assets/css/font.css";
import "../../assets/css/base.css";
import "../../assets/css/sprites.css";
import "../../assets/css/animation.css";
import "../../assets/css/react-transitions.css";
import "../../assets/css/tripMoneySprites.css";
import "../../assets/css/ThankYou.css";
import {
  DISPLAY_ERROR_PAGE,
  LOGIN_REQUIRED,
  INTERNAL_ERROR,
  EXIT,
} from "../../constants";
import { Helmet } from "react-helmet";
import { redirectIntercept } from "../Forex/util/common";
import { getForexBasePath, goToLanding } from "../Forex/util";
import {
  FOREX_BMF_GOIBIBO,
  FOREX_BMF_MAKEMYTRIP,
} from "../Forex/util/constants";
import { setOtherInfo } from '../../reducers/otherInfo';
import { getUserId, setUserIdInPagesenseRecording } from '../../utils/common';

/**
 * Root/Template component
 */
const App = (props) => {
  const loading = useSelector((state) => state.loading);
  const agentLogin = useSelector((state) => state.agentLogin);
  const dispatch = useDispatch();
  const error = useSelector((state) => state.error);
  const programs = useSelector(
    (state) =>
      state &&
      state.getPrograms &&
      state.getPrograms.data &&
      state.getPrograms.data.programs
  );
  const stageDetails = useSelector((state) =>
    state.stage.data ? state.stage.data.stageDetails : {}
  );
  const otherInfo = useSelector(state => state.otherInfo)
  const user = useSelector(state => state.user ? state.user : {});
  const userId = getUserId(user);

  const moveToLanding = () => {
    if (
      programs &&
      programs.length &&
      (programs.indexOf(FOREX_BMF_MAKEMYTRIP) != -1 ||
        programs.indexOf(FOREX_BMF_GOIBIBO) != -1)
    ) {
      redirectIntercept(`${getForexBasePath()}`);
    } else {
      goToLanding(otherInfo);
    }
  }

  const onErrorDismiss = () => {
    dispatch(setError({ viewed: true, description: "", code:"", otherInfo:null  }))
    dispatch(setOtherInfo({...otherInfo, requestData:null}))
    if (error?.cta?.url) {
      redirectIntercept(error.cta.url);
      return;
    }
    if (error?.cta?.func && window?.app_bridge?.navigateToPermission) {
      window.app_bridge.navigateToPermission();
      return;
    }
    if (error.code == "CLOSE_WEBVIEW") {
      try {
        if (window.mmt_android_bridge)
          window.mmt_android_bridge.closeAndRefreshWebView();
        else moveToLanding();
      } catch (e) { }
    } else if (error && error.cta && error.cta.action === EXIT) {
      moveToLanding();
    }
  };

  const checkIfErrorIsHandled = () => {
    let errorCodes = [DISPLAY_ERROR_PAGE, LOGIN_REQUIRED, INTERNAL_ERROR];
    if (error && errorCodes.indexOf(error.code) != -1) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    history.listen((location) => {
      dispatch(setLoading(false));
    });
    //dispatch(getConfig())
  }, []);

  useEffect(() => {
    if(userId){
      setUserIdInPagesenseRecording(userId)
    }
  }, [userId])

  useEffect(() => {
    window.onpopstate = (e) => {
      try {
        if (
          (window.location.pathname.indexOf("onboarding") != -1 &&
            stageDetails &&
            stageDetails.stageName !== "kissht_si_bank_details") ||
          window.location.pathname == "/kissht/setup-si"
        ) {
          dispatch(setLoading(true));
          console.log("Back button pressed");
          history.go(-(history.length - 1));
          if (window.mmt_android_bridge) {
            window.mmt_android_bridge.closeAndRefreshWebView();
          }
        }
      } catch (e) { }
    };
  }, [stageDetails, props.location]);

  return (
    <BrowserRouter>
      <React.Fragment>
        {/* For special loader, set loader in setLoader and specialLoader to true */}
        {loading.specialLoader ? (
          <LoadingOverlay
            styles={{
              wrapper: {},
              overlay: {},
              content: {},
              spinner: {},
            }}
            active={loading.status}
          >
            <div style={{ minHeight: "100vh" }} className="">
              {loading.loader}
            </div>
          </LoadingOverlay>
        ) : (
          <LoadingOverlay
            style={{ padding: "20px" }}
            active={loading.status}
            spinner
            text={loading.message}
          >
            <div style={{ minHeight: "100vh" }} className="">
              <Router agentLogin={agentLogin} />
            </div>
          </LoadingOverlay>
        )}
        {!error.viewed && !checkIfErrorIsHandled() && (
          <Popup handleClosePopup={() => onErrorDismiss()}>
            <PopupCardTemplate
              heading=""
              handleClosePopup={() => onErrorDismiss()}
              themeNumber={0}
              isCloseButtonDisable
            >
              <NotificationAlertCard
                message={
                  error.code == "DISPLAY_ERROR" || "CLOSE_WEBVIEW"
                    ? error.description
                    : ""
                }
                handleClosePopup={() => onErrorDismiss()}
                negativeButtonTitle={
                  error && error.cta && error.cta.text
                    ? error.cta.text
                    : "Close"
                }
                heading={error?.headingText ? error?.headingText : "Oops!"}
              />
            </PopupCardTemplate>
          </Popup>
        )}
      </React.Fragment>
      <Helmet>
        <title>Tripmoney</title>
        <meta name="description" content="" />
      </Helmet>
    </BrowserRouter>
  );
};

export default App;

// const mapStateToProps = (state, ownProps) => {
//   return {
//     agentLogin: state.agentLogin,
//     loading: state.loading,
//   }
// };

// const actionCreators = {
//   getUser,
//   getConfig
// };

// export default connect(
//   mapStateToProps,
//   actionCreators,
// )(App);
